import React from 'react';
import { Field } from "formik";
import TextArea, { BaseProps } from '../base/TextArea';
import { FieldProps } from 'formik';
import { ErrorText } from '.';

type Props = BaseProps & {
    name: string;
};

const FormTextArea = ({ name, ...restProps }: Props) => {
    return (
        <Field name={name}>
            {({ field, meta }: FieldProps) => {
                const { touched, error } = meta;
                const hasError = touched && error !== undefined;
                return (
                    <div>
                        <TextArea field={field} hasError={hasError} {...restProps} />
                        <ErrorText>{hasError && error}</ErrorText>
                    </div>
                );
            }}
        </Field>
    );
};
export default FormTextArea;
